/**
 * SPEC-CHINA-GEO-EDITOR-FIELD-UX-001 M-c(§2.3-①lite): menu.link → 미보유 모듈 매핑 산출(순수 함수).
 *
 * MenuModal.vue의 `missingModuleMenuMap` computed에서 위임 호출한다. 별도 .js 파일로 분리한 이유는
 * MenuModal.vue의 <style lang="scss"> 블록이 vitest(vite:css, css:false 설정에도 불구)에서
 * sass 버전 충돌로 컴파일 실패하기 때문 — .vue를 직접 import하면 테스트가 아예 뜨지 못한다
 * (tests/unit/geo/costCellState.test.js 등 기존 관례와 동일하게 로직만 .js로 분리).
 *
 * fail-quiet(J5·J7) — moduleContext=null·link 미매핑·MISSING 원장이면 빈 Map.
 *
 * @param {Array<{name:string, menu:Array<{menuId:string, link:string}>}>} categories
 * @param {{ledgerState?:string, heldModuleCodes?:string[], linkToModule?:Object<string,{code:string,label:string}>}|null} moduleContext
 * @returns {Map<string,{code:string,label:string}>} menuId -> { code, label }
 */
export function computeMissingModuleMenuMap(categories, moduleContext) {
  const map = new Map();
  if (!moduleContext || !moduleContext.linkToModule) return map;
  if (moduleContext.ledgerState === 'MISSING') return map;
  const held = new Set(moduleContext.heldModuleCodes || []);
  (categories || []).forEach((cat) => {
    (cat.menu || []).forEach((menu) => {
      const mapped = moduleContext.linkToModule[menu.link];
      if (mapped && !held.has(mapped.code)) {
        map.set(menu.menuId, mapped);
      }
    });
  });
  return map;
}

/**
 * 보유(양성) 모듈 매핑 — 미보유 경고와 대칭. 편집 중 "이 메뉴가 어느 보유 모듈 덕에
 * 쓰이는가"를 보여주기 위한 정보 제공 전용(저장·검증 무관, 비차단 원칙 동일).
 * fail-quiet — moduleContext=null·link 미매핑·MISSING 원장이면 빈 Map.
 *
 * @param {Array<{name:string, menu:Array<{menuId:string, link:string}>}>} categories
 * @param {{ledgerState?:string, heldModuleCodes?:string[], linkToModule?:Object<string,{code:string,label:string}>}|null} moduleContext
 * @returns {Map<string,{code:string,label:string}>} menuId -> { code, label }
 */
export function computeHeldModuleMenuMap(categories, moduleContext) {
  const map = new Map();
  if (!moduleContext || !moduleContext.linkToModule) return map;
  if (moduleContext.ledgerState === 'MISSING') return map;
  const held = new Set(moduleContext.heldModuleCodes || []);
  (categories || []).forEach((cat) => {
    (cat.menu || []).forEach((menu) => {
      const mapped = moduleContext.linkToModule[menu.link];
      if (mapped && held.has(mapped.code)) {
        map.set(menu.menuId, mapped);
      }
    });
  });
  return map;
}
